import React, { useRef, useState } from 'react'
import ReactPlayer from 'react-player'
import { useHistory, useLocation } from 'react-router-dom'

import './ReactPlayerContribution.sass'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../store/rootReducer'
import { ContributionType } from '../../../store/contributions/contributionsTypings'
import { openPremiumDialog, setPageToReturnFromPayment, switchMenu } from '../../../store/common/commonSlice'

import { createLocalizedPath } from '../../../utils/localizationHelpers'
import paths from '../../../paths'

import { useTranslation } from 'react-i18next'
import { isUserPro } from '../../../utils/isUserPro'
import LoginDialog from '../../../components/informationWindow/loginDialog'
import { createPortal } from 'react-dom'

interface Props {
    item: {
        url: string
        thumbnail_url: string
    }
}
const ReactPlayerContributions: React.FunctionComponent<Props> = ({ item }: Props) => {
    const [t] = useTranslation()
    const location = useLocation()
    const reactPlayerRef = useRef()
    const history = useHistory()
    const dispatch = useDispatch()

    const { user } = useSelector((state: RootState) => state.member)
    const { member_type } = user || { member_type: undefined }
    const contribution = useSelector<RootState, ContributionType>((state) => state.contributions.contribution)
    const { pro } = contribution
    const [showMembershipRequest, setShowMembershipRequest] = useState(false)
    const [loginDialog, setLoginDialog] = useState(false)

    const isUserNotActive = () => user && user.active === 0

    const handleDownloadVideo = () => {
        if (!user) {
            setLoginDialog(true)
            return
        }
        if (!user || !isUserPro(user.member_type)) {
            dispatch(openPremiumDialog())
            return
        }
        if (typeof window !== 'undefined') window.open(item.url + '&t=download')
    }

    return (
        <>
            <ReactPlayer
                ref={reactPlayerRef}
                onProgress={() => {
                    if (location.pathname.split('/').reverse()[1] !== item.url.split('=')[1]) {
                        if (reactPlayerRef.current) {
                            // @ts-ignore
                            reactPlayerRef.current.showPreview()
                        }
                    }
                }}
                onContextMenu={(e: React.FormEvent<HTMLInputElement>) => e.preventDefault()}
                controls
                playsinline
                stopOnUnmount={false}
                width="100vw"
                height="100vh"
                url={item.url + `${user && isUserPro(user.member_type) ? '&t=fullsize' : ''}`}
                playing
                // light={item.thumbnail_url}
                onEnded={() => setShowMembershipRequest(true)}
                config={{ file: { attributes: { controlsList: 'nodownload' } } }}
                style={{
                    background: `url(${item.thumbnail_url}) no-repeat center calc(50% - 50px)`,
                    backgroundSize: 'contain'
                }}
            />
            <img
                className={'downloadVideo'}
                src={require('./../../../assets/ic-download.svg')}
                onClick={handleDownloadVideo}
            />
            {!showMembershipRequest &&
            (!user || !isUserPro(member_type)) &&
            pro === 1 &&
            !(user && user.id == contribution.user.id) ? (
                <div>
                    <div className={'videoBlur onlyForPro'} />
                </div>
            ) : (
                <></>
            )}
            {showMembershipRequest && pro === 1 && !isUserPro(member_type) && (
                <div
                    className="membershipRequest"
                    onClick={() => {
                        setShowMembershipRequest(false)
                    }}
                >
                    <div className="content-no-xxl-member">
                        {user && !isUserNotActive() && <p>{t('Become a member to watch the rest of the video')}</p>}
                        {user && isUserNotActive() && (
                            <p>{t('Activate your account to watch the rest of the video')}</p>
                        )}
                        {!user && <p>{t('Please log in to watch the rest of the video')}</p>}
                        {user ? (
                            <button
                                className="login-button"
                                onClick={(e) => {
                                    e.stopPropagation()
                                    if (isUserNotActive()) {
                                        history.push(location.pathname + '?activate')
                                    } else {
                                        history.push(createLocalizedPath(paths.payment.path))
                                        dispatch(setPageToReturnFromPayment(location.pathname))
                                    }
                                }}
                            >
                                {isUserNotActive() ? t('Activate') : t('Become an XXL member')}
                            </button>
                        ) : (
                            <button
                                className="login-button"
                                onClick={() => {
                                    dispatch(switchMenu())
                                }}
                            >
                                {t('Log in')}
                            </button>
                        )}
                    </div>
                </div>
            )}
            {typeof window !== 'undefined' ? (
                createPortal(<LoginDialog loginDialog={loginDialog} setLoginDialog={setLoginDialog} />, document.body)
            ) : (
                <></>
            )}
        </>
    )
}

export default ReactPlayerContributions
